var _ = function(selector) { return document.querySelector(`${selector}`); }
var __ = function(selector) { return document.querySelectorAll(`${selector}`); }
var isAllInOnePackage = meta.product.id === 6569835888695 ? true : false;

$(document).ready(function() {
	// init package without variant
	if (!hasVariants()) {
		// let package = document.querySelector('.package-selection');
		let package = document.querySelector('.ysd-custom-product-options');
		console.log(package);

		init(package);
		removeOverlay();
	}

	// init package with variants
	if (hasVariants()) {
		var variantOptions = document.querySelectorAll('.variant-field');
		// var newPackageBtn = document.querySelector('.new');
		// var oldPackageBtn = document.querySelector('.old');

		// only for all-in-1 package, on page load
		// if (isAllInOnePackage) {
		// 	newPackageBtn.addEventListener('click', newPackageBtnClicked);
		// 	oldPackageBtn.addEventListener('click', oldPackageBtnClicked);
		// }		

		// init variants
		variantOptions.forEach(option => {
			option.addEventListener('click', function() {
				hideAllPackageForms();

				var package = document.querySelector(`.ysd-custom-product-options[data-name="${this.querySelector('input').value}"]`);

				init(package);
			})
		})

		removeOverlay();
		setTimeout(selectFirstVariant, 1000);
	}


	function init(package) {
		var selects = package.querySelectorAll('select:not(.hide)');
		var productOptionsInsidePackage = package.querySelectorAll('.prod-options, .gifts, .pick-gifts');

		package.classList.remove('hide');
		selects.forEach(select => {
			select.disabled = false;
		})
		productOptionsInsidePackage.forEach(option => {
			option.classList.remove('hide');
		})

		initPackageProduct(package);
		initPackageReset(package);
	}	

	function newPackageBtnClicked(evt) {
		console.log('new clicked');
		var package = document.querySelector('.ysd-custom-product-options:not(.hide)');
		var teaWrappers = document.querySelectorAll('.chrysanthemum');
		var teas = document.querySelectorAll('.chrysanthemum select');
		teaWrappers.forEach(w => {
			w.classList.remove('hide');
		})

		teas.forEach(t => {
			t.classList.remove('hide');
			t.disabled = true;
		});
		init(package);
	}

	function oldPackageBtnClicked(evt) {
		console.log('old clicked');
		var package = document.querySelector('.ysd-custom-product-options:not(.hide)');
		var teaWrappers = document.querySelectorAll('.chrysanthemum');
		var teas = document.querySelectorAll('.chrysanthemum select');
		teaWrappers.forEach(w => {
			w.classList.add('hide');
		})

		teas.forEach(t => {
			t.classList.add('hide');
			t.disabled = true;
		});

		init(package);
	}

	function removeOverlay() {
		var form = _('.productForm');

		return form.classList.remove('package-form-overlay');
	}

	function hasVariants() {
		return document.querySelectorAll('.variant-field').length > 0 ? true : false;
	}

	function selectFirstVariant() {
		let firstVariantWrapper = document.querySelector('.variant__button-label');
		let firstVariantInput = document.querySelector('.variant-field input');
		let hiddenProductSelect = document.querySelector('[name="id"]');

		firstVariantWrapper.click();
		firstVariantInput.checked = true;
		hiddenProductSelect.selectedIndex = 0;

		return;
	}

	function hideAllPackageForms() {
		let packageForms = document.querySelectorAll('.ysd-custom-product-options, .prod-options');
		let productOptions = document.querySelectorAll('.gifts, .pick-gifts');
		let selects = document.querySelectorAll('.ysd-custom-product-options select');

		packageForms.forEach(form => {
			form.classList.add('hide');
		})

		productOptions.forEach(option => {
			option.classList.add('hide');
		})

		selects.forEach(select => {
			select.disabled = true;
		})
	}

	function initPackageProduct(package) {
		let packageReminder = package.querySelector('.package-reminder-snack-1');
		let totalPacks = package.querySelector('.package-reminder-snack-1').dataset.totalPacks;
		let teaTypes = package.querySelectorAll('.tea-type-snack-1:not(.hide)');

		teaTypes.forEach(tea => {
			tea.addEventListener('change', function() {
				var packageCount = calcPackageCount(package, totalPacks);

				updatePackageReminder(packageReminder, packageCount);

				if (packageCount !== 0) return disableAddToCartButton();

				return enableAddToCartButton();
			})

			presetTeaPackNumber(package, totalPacks, tea, packageReminder);
		})

		if(package.querySelector('.package-reminder-snack-2') !==  null){
			let packageReminder2 = package.querySelector('.package-reminder-snack-2');
			let totalPacks2 = package.querySelector('.package-reminder-snack-2').dataset.totalPacks;
			let teaTypes2 = package.querySelectorAll('.tea-type-snack-2:not(.hide)');

			teaTypes2.forEach(tea => {
				tea.addEventListener('change', function() {
					var packageCount = calcPackageCount2(package, totalPacks2);

					updatePackageReminder(packageReminder2, packageCount);

					if (packageCount !== 0) return disableAddToCartButton();

					return enableAddToCartButton();
				})

				presetTeaPackNumber(package, totalPacks2, tea, packageReminder2);
			})
		}

		if(package.querySelector('.package-reminder-snack-3') !==  null){
			let packageReminder3 = package.querySelector('.package-reminder-snack-3');
			let totalPacks3 = package.querySelector('.package-reminder-snack-3').dataset.totalPacks;
			let teaTypes3 = package.querySelectorAll('.tea-type-snack-3:not(.hide)');

			teaTypes3.forEach(tea => {
				tea.addEventListener('change', function() {
					var packageCount = calcPackageCount3(package, totalPacks3);

					updatePackageReminder(packageReminder3, packageCount);

					if (packageCount !== 0) return disableAddToCartButton();

					return enableAddToCartButton();
				})

				presetTeaPackNumber(package, totalPacks3, tea, packageReminder3);
			})
		}

		if(package.querySelector('.package-reminder-snack-4') !==  null){
			let packageReminder4 = package.querySelector('.package-reminder-snack-4');
			let totalPacks4 = package.querySelector('.package-reminder-snack-4').dataset.totalPacks;
			let teaTypes4 = package.querySelectorAll('.tea-type-snack-4:not(.hide)');

			teaTypes4.forEach(tea => {
				tea.addEventListener('change', function() {
					var packageCount = calcPackageCount4(package, totalPacks4);

					updatePackageReminder(packageReminder4, packageCount);

					if (packageCount !== 0) return disableAddToCartButton();

					return enableAddToCartButton();
				})

				presetTeaPackNumber(package, totalPacks4, tea, packageReminder4);
			})
		}

		setTimeout(function() {
			let packageCount = calcPackageCount(package, totalPacks);

			if (packageCount !== 0) return disableAddToCartButton();
		}, 500)
	}

	function initPackageReset(package) {
		let packageReset = package.querySelector('.package-reset-snack-1');
		let teaTypes = package.querySelectorAll('.tea-type-snack-1:not(.hide)');
		let packageReminder = package.querySelector('.package-reminder-snack-1');
		
		let packageReset2 = package.querySelector('.package-reset-snack-2');
		let teaTypes2 = package.querySelectorAll('.tea-type-snack-2:not(.hide)');
		let packageReminder2 = package.querySelector('.package-reminder-snack-2');

		let packageReset3 = package.querySelector('.package-reset-snack-3');
		let teaTypes3 = package.querySelectorAll('.tea-type-snack-3:not(.hide)');
		let packageReminder3 = package.querySelector('.package-reminder-snack-3');

		let packageReset4 = package.querySelector('.package-reset-snack-4');
		let teaTypes4 = package.querySelectorAll('.tea-type-snack-4:not(.hide)');
		let packageReminder4 = package.querySelector('.package-reminder-snack-4');

		packageReset.addEventListener('click', function() {
			// reset tea 
			teaTypes.forEach(tea => {
				tea.value = 0;
			})

			// reset reminder
			packageReminder.innerText = `你還可選擇 ${packageReminder.dataset.totalPacks} 包`;

			// disable add to cart button
			disableAddToCartButton();
		})
		if(packageReset2){
			packageReset2.addEventListener('click', function() {
				// reset tea 
				teaTypes2.forEach(tea => {
					tea.value = 0;
				})

				// reset reminder
				packageReminder2.innerText = `你還可選擇 ${packageReminder2.dataset.totalPacks} 包`;

				// disable add to cart button
				disableAddToCartButton();
			})
		}

		if(packageReset3){
			packageReset3.addEventListener('click', function() {
				// reset tea 
				teaTypes3.forEach(tea => {
					tea.value = 0;
				})

				// reset reminder
				packageReminder3.innerText = `你還可選擇 ${packageReminder3.dataset.totalPacks} 包`;

				// disable add to cart button
				disableAddToCartButton();
			})
		}

		if(packageReset4){
			packageReset4.addEventListener('click', function() {
				// reset tea 
				teaTypes4.forEach(tea => {
					tea.value = 0;
				})

				// reset reminder
				packageReminder4.innerText = `你還可選擇 ${packageReminder4.dataset.totalPacks} 包`;

				// disable add to cart button
				disableAddToCartButton();
			})
		}
	}

	function presetTeaPackNumber(package, totalPacks, tea, packageReminder) {
		// if (tea.dataset.preset !== undefined) {

			// preset for all in 1 package
			// if (isAllInOnePackage) {
			// 	tea.value = tea.dataset.preset;

			// 	updatePackageReminder(packageReminder, calcPackageCount(package, totalPacks));

			// 	return enableAddToCartButton();
			// }

			// preset for all other packages
			tea.value = tea.dataset.preset;
			updatePackageReminder(packageReminder, calcPackageCount(package, totalPacks));

			return enableAddToCartButton();
		// } 
	}

	function calcPackageCount(package, totalPacks) {
		let reducer = (accumulator, currentValue) => accumulator + currentValue;
		// console.log("currentValue: "+currentValue);
		let packageCount = totalPacks - [...package.querySelectorAll('.tea-type-snack-1:not(.hide)')]
			.map(tea => Number(tea.value))
			.reduce(reducer);

		return packageCount;
	}

	function calcPackageCount2(package, totalPacks) {
		let reducer = (accumulator, currentValue) => accumulator + currentValue;
		// console.log("currentValue: "+currentValue);
		let packageCount = totalPacks - [...package.querySelectorAll('.tea-type-snack-2:not(.hide)')]
			.map(tea => Number(tea.value))
			.reduce(reducer);

		return packageCount;
	}

	function calcPackageCount3(package, totalPacks) {
		let reducer = (accumulator, currentValue) => accumulator + currentValue;
		// console.log("currentValue: "+currentValue);
		let packageCount = totalPacks - [...package.querySelectorAll('.tea-type-snack-3:not(.hide)')]
			.map(tea => Number(tea.value))
			.reduce(reducer);

		return packageCount;
	}

	function calcPackageCount4(package, totalPacks) {
		let reducer = (accumulator, currentValue) => accumulator + currentValue;
		// console.log("currentValue: "+currentValue);
		let packageCount = totalPacks - [...package.querySelectorAll('.tea-type-snack-4:not(.hide)')]
			.map(tea => Number(tea.value))
			.reduce(reducer);

		return packageCount;
	}

	function updatePackageReminder(reminder, packageCount) {
		if (packageCount === 0) {
			reminder.innerText = '已選好零食，請將套裝加進購物車';
		}
		var unit = "個";
		if (packageCount > 0) {
			reminder.innerText = `你還可選擇 ${packageCount} ${unit}`;
		}

		if (packageCount < 0) {
			reminder.innerText = `你多選了 ${Math.abs(packageCount)} ${unit}`;
		}
	}

	function enableAddToCartButton() {
		let addToCartBtn = document.querySelector('.productForm-submit');
		if($('.total-tea').length>0){
			let total_tea = $('.total-tea').val();
			if(total_tea != 3){
				$(".productForm-submit").prop('disabled', true);
				return;
			}
		}
		return addToCartBtn.disabled = false;
	}

	function disableAddToCartButton() {
		let addToCartBtn = document.querySelector('.productForm-submit');

		console.log('disabled');
		return addToCartBtn.disabled = true;
	}
})
